export type LoadedInfoState = 'NOT_LOADED' | 'LOADED' | 'NOT_FOUND' | 'UNAUTHORIZED'
export interface IPlaylistData {
  name: string
  code: string
  talents: any[]
}

export const enterprisePlaylistInitialState = {
  isLoading: false,
  loadedInfoState: 'NOT_LOADED' as LoadedInfoState,
  playlist: null as IPlaylistData
}

export type EnterprisePlaylistState = typeof enterprisePlaylistInitialState
